// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__tx1kx","gradient":"styles_gradient__H5pBn","paginationElement":"styles_paginationElement__RZo1s"};